import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Row, Col, Container } from 'react-bootstrap';

import { Address } from '../FormFields/Address';
import { pyroSiteSchema } from '../../schemas/pyroSiteSchema';
import { ControlButtons } from '../ControlButtons';
import { DatesAndTimes } from '../FormFields/DatesAndTimes';

export const PyrotechnicsSite = ({
	currPyroSite = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState, unregister } = useForm({
		resolver: yupResolver(pyroSiteSchema),
		defaultValues: currPyroSite,
	});

	return (
		<Container className="component">
			<Container className="p-0 mt-5 component">
				<h2 className="mb-4">Where is the display site?</h2>
				<Row>
					<Col xs="12" sm="6">
						<Form.Group>
							<Form.Label>Lot Size in Acres</Form.Label>
							<Form.Control type="number" autoFocus {...register('size')} />
							<Form.Text className="text-danger">
								{formState.errors.size?.message}
							</Form.Text>
						</Form.Group>
					</Col>
					<Col xs="12" sm="6">
						<Form.Group>
							<Form.Label>Anticipated Number of Participants</Form.Label>
							<Form.Control type="number" {...register('attendants')} />
							<Form.Text className="text-danger">
								{formState.errors.attendants?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
				<Address register={register} error={formState.errors}></Address>
				<hr />
				<DatesAndTimes
					currDatesAndTimes={currPyroSite.dateAndTimes}
					unregister={unregister}
					register={register}
					error={formState.errors}></DatesAndTimes>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}></ControlButtons>
		</Container>
	);
};
